import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// AppKit modules

// PrimeNG modules
// Material modules
import { AppNgAppkitModule } from '../../../app-ng-appkit.module';
import { AppNgMaterialModule } from '../../../app-ng-material.module';

// Shared modules
import { SharedComponentsModule } from '../../../shared/components/shared-components.module';
import { SharedPipesModule } from '../../../shared/pipes/shared-pipe.module';
import { SharedDirectivesModule } from '../../../shared/_directives/shared-directives.module';

// Components
import { F1065K2P3S4Component } from './f1065-k2-p3s4/f1065-k2-p3s4.component';
import { F1065K2P7S1Component } from './f1065-k2-p7s1/f1065-k2-p7s1.component';
import { F1065K2P7S2Component } from './f1065-k2-p7s2/f1065-k2-p7s2.component';
import { F1065K2P1S0Component } from './f1065-k2-p1s0/f1065-k2-p1s0.component';
import { F1065K2P10S3Component } from './f1065-k2-p10s3/f1065-k2-p10s3.component';
import { F1065K2P11S0Component } from './f1065-k2-p11s0/f1065-k2-p11s0.component';
import { F1065K2P12S0Component } from './f1065-k2-p12s0/f1065-k2-p12s0.component';
import { F1065K2P13S0Component } from './f1065-k2-p13s0/f1065-k2-p13s0.component';
import { F1065K2HeaderComponent } from './f1065-k2-header/f1065-k2-header.component';
import { F1065K2DataEntryComponent } from './f1065-k2-data-entry/f1065-k2-data-entry.component';

@NgModule({ declarations: [
        F1065K2P3S4Component,
        F1065K2P7S1Component,
        F1065K2P7S2Component,
        F1065K2P1S0Component,
        F1065K2P10S3Component,
        F1065K2P11S0Component,
        F1065K2P12S0Component,
        F1065K2P13S0Component,
        F1065K2HeaderComponent,
        F1065K2DataEntryComponent
    ],
    exports: [
        F1065K2P3S4Component,
        F1065K2P7S1Component,
        F1065K2P7S2Component,
        F1065K2P1S0Component,
        F1065K2P10S3Component,
        F1065K2P11S0Component,
        F1065K2P12S0Component,
        F1065K2P13S0Component,
        F1065K2HeaderComponent,
        F1065K2DataEntryComponent
    ], imports: [CommonModule,
        FormsModule,
        AppNgAppkitModule,
        AppNgMaterialModule,
        SharedComponentsModule,
        SharedPipesModule,
        SharedDirectivesModule], })
export class F1065K2Module { }
